export default __webpack_public_path__ + "static/media/open_small.87b06fc8.svg";